<div class="{{groupCss}}">
  <ng-template #learningActivitiesContainer></ng-template>
</div>